import { anyChangesExistOnDimensionEditSelector } from "./anyChangesExistOnDimensionEditSelector";
import { categoriesCreationDataIsInvalidSelector } from "../categories/categoriesCreationDataIsInvalidSelector";
import { dimensionNameSelector } from "../../slice-data/dimensionNameSelector";
import { dimensionCategoriesEntriesSelector } from "../../slice-data/categories/dimensionCategoriesEntriesSelector";
import { RootState } from "@/store/store";
import { dimensionMaxCharacter } from "@/components/pages/dimensions/components/form-drawer/components/dimension/utils/constants";
import { dimensionsSharedCostsDataIsInvalidSelector } from "@/store/dimensions/selectors/options/shared-costs/dimensionsSharedCostsDataIsInvalidSelector";

export const dimensionCreateDisabledSelector = (state: RootState) => {
  const dimensionName = dimensionNameSelector(state);
  const categories = dimensionCategoriesEntriesSelector(state);
  const categoriesInvalid = categoriesCreationDataIsInvalidSelector(state);
  const somethingChanged = anyChangesExistOnDimensionEditSelector(state);
  const sharedCostsInvalid = dimensionsSharedCostsDataIsInvalidSelector(state);

  return (
    !dimensionName.trim() ||
    dimensionName?.length > dimensionMaxCharacter ||
    !categories.length ||
    categoriesInvalid ||
    sharedCostsInvalid ||
    !somethingChanged
  );
};
